/* eslint-disable no-var */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext, useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Box, CssBaseline } from '@material-ui/core';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AppDrawer } from '../../components';
import { mainmenu } from '../../constants';
import { GlobalContext } from '../../contexts';
import { layoutClasses } from '../../themes';
import Options from '../options';
import { Accounts } from '../adds';
import { GContextTypes } from '../../types';

import { useBranches } from '../../hooks';
import PageLayout from './PageLayout';
import useAccounts from '../../hooks/useAccounts';
import Branches from '../adds/Branches';
import React from 'react';
import AlertWithClose from '../../components/fields/AlertWithClose';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import useCompany from '../../hooks/useCompany';
import Notifications from '../adds/Notifications';
import { useLazyQuery, useSubscription } from '@apollo/client';
import { notifiAdded } from '../../graphql/subscription';
import AdminLanding from './AdminLanding';
import {
  addsList,
  financeList,
  reminderList,
  reportsList,
  tadweenList,
} from '../../constants/menu';
import FinanceOperations from '../../Sections/Finance/FinanceOperations';
import BasicsAdd from '../../Sections/Basics/BasicsAdd';
import ReminderOperations from '../../Sections/Reminder/ReminderOperations';
import LandingOperations from '../../Sections/Landing/LandingOperations';
import ReportsList from '../../Sections/reports/ReportsList';
import getMyInbox from '../../graphql/query/getMyInbox';

import TadweenOperations from '../../Sections/Tadween/TadweenOperations';
import { filterMenu } from '../../common/helpers';
import { isSuperAdmin } from '../../common/roles';
import AllUsers from '../adds/AllUsers';

const Content = ({ formdocs }: any) => {
  const classes = layoutClasses();
  const [mmenu, setMmenu] = useState(null);
  const [menuitem, setMenuitem] = useState(mainmenu[0]);
  const [drawerWidth, setDrawerWidth] = useState(80);
  const [open, setOpen] = React.useState(false);
  const [newin, setNewin] = useState(0);

  const theme = useTheme();
  const location = useLocation();
  const pathname = location?.pathname;

  useEffect(() => {
    if (pathname && pathname.length > 0) {
      if (pathname === '/') {
        setMenuitem(mainmenu[0]);
      } else {
        const pname = pathname?.split('/')?.[1];
        const mitem = mainmenu?.filter(
          (mi: any) => mi.uri === `/${pname}`
        )?.[0];
        if (mitem && mitem !== menuitem) {
          setMenuitem(mitem);
        }
      }
    }
  }, [pathname]);

  const { company, editCompany, refreshcompany } = useCompany();
  const { branches } = useBranches();
  const { accounts, refreshAccount } = useAccounts();
  const {
    store: { user, network, packIssue, packIssueMsg, notify, scrollbar },
    dispatch,
    translate: { words, isRTL },
  }: GContextTypes = useContext(GlobalContext);
  const { isMobile } = useWindowDimensions();

  const logout = () => {
    dispatch({ type: 'logout' });
  };
  const isAccountant = user?.isAccountant;

  const notifisub = useSubscription(notifiAdded, {
    fetchPolicy: 'network-only',
    shouldResubscribe: true,
  });

  // Load inbox budge
  const [loadInbox, inboxData]: any = useLazyQuery(getMyInbox);
  useEffect(() => {
    const d = inboxData?.data?.getMyInbox?.data;
    if (d) {
      const newin = d.filter((i: any) => !i.read)?.length;
      setNewin(newin);
    }
  }, [inboxData]);

  useEffect(() => {
    loadInbox({ skip: 0 });
  }, []);
  const isPOS = pathname === '/pos';
  return (
    <Box
      className={classes.root}
      dir={isRTL ? 'rtl' : undefined}
      display="flex"
      style={{
        flex: 1,
      }}
    >
      <CssBaseline />
      {!isPOS && (
        <AppDrawer
          isRTL={isRTL}
          setMenuitem={setMenuitem}
          menuitem={menuitem}
          user={user}
          branches={branches}
          menu={filterMenu(isMobile)}
          logout={logout}
          network={network}
          setMmenu={setMmenu}
          mmenu={mmenu}
          notify={notify}
          company={company}
          scrollbar={scrollbar}
          drawerWidth={drawerWidth}
          setDrawerWidth={setDrawerWidth}
          open={open}
          setOpen={setOpen}
          newin={newin}
        ></AppDrawer>
      )}
      <main
        style={{ marginTop: isMobile ? 50 : undefined }}
        className={classes.content}
      >
        <Routes>
          <Route
            path="/"
            element={
              isAccountant || isSuperAdmin ? (
                <AdminLanding
                  menuitem={menuitem}
                  isRTL={isRTL}
                  words={words}
                  user={user}
                  theme={theme}
                  company={company}
                  dispatch={dispatch}
                ></AdminLanding>
              ) : (
                <LandingOperations
                  menuitem={menuitem}
                  isRTL={isRTL}
                  words={words}
                  user={user}
                  theme={theme}
                  company={company}
                  dispatch={dispatch}
                  notifisub={notifisub}
                ></LandingOperations>
              )
            }
          />
          {(isAccountant || isSuperAdmin) && (
            <Route
              path="/main"
              element={
                <LandingOperations
                  menuitem={menuitem}
                  isRTL={isRTL}
                  words={words}
                  user={user}
                  theme={theme}
                  company={company}
                  dispatch={dispatch}
                  notifisub={notifisub}
                ></LandingOperations>
              }
            />
          )}
          <Route
            path={'/tadween/*'}
            element={
              <TadweenOperations
                menuitem={menuitem}
                formgroup={tadweenList}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></TadweenOperations>
            }
          />
          <Route
            path={'/finance/*'}
            element={
              <FinanceOperations
                menuitem={menuitem}
                formgroup={financeList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></FinanceOperations>
            }
          />
          <Route
            path={'/basicadd/*'}
            element={
              <BasicsAdd
                menuitem={menuitem}
                formgroup={addsList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></BasicsAdd>
            }
          />
          <Route
            path={'/reports/*'}
            element={
              <ReportsList
                menuitem={menuitem}
                formgroup={reportsList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></ReportsList>
            }
          />
          <Route
            path="/reminder/*"
            element={
              <ReminderOperations
                menuitem={menuitem}
                formgroup={reminderList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
              ></ReminderOperations>
            }
          />
          <Route
            path="/notifications"
            element={
              <Notifications
                isRTL={isRTL}
                words={words}
                theme={theme}
                menuitem={menuitem}
                notify={notify}
                dispatch={dispatch}
                company={company}
                user={user}
              ></Notifications>
            }
          />
          <Route
            path="/users"
            element={
              <AllUsers
                words={words}
                menuitem={menuitem}
                theme={theme}
                isRTL={isRTL}
                user={user}
                drawerWidth={drawerWidth}
              ></AllUsers>
            }
          />
          <Route
            path="/accounts"
            element={
              <PageLayout
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
                refresh={refreshAccount}
              >
                <Accounts accounts={accounts}></Accounts>
              </PageLayout>
            }
          />
          {user.isSuperAdmin && (
            <Route
              path="/branches"
              element={
                <PageLayout
                  menuitem={menuitem}
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                >
                  <Branches
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                  ></Branches>
                </PageLayout>
              }
            />
          )}
          <Route
            path="/options"
            element={
              <PageLayout
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
                refresh={refreshcompany}
                editCompany={editCompany}
                company={company}
              >
                <Options></Options>
              </PageLayout>
            }
          />
        </Routes>
        <AlertWithClose
          open={packIssue}
          dispatch={dispatch}
          isRTL={isRTL}
          msg={packIssueMsg}
          onClose={() => dispatch({ type: 'closePackIssue' })}
        ></AlertWithClose>
      </main>
    </Box>
  );
};
export default Content;
